/* eslint-disable import/no-anonymous-default-export */
export default () => {


  let date = new Date();

  function getYearsStats() {
    var n = date.getFullYear() - 5;
    var arrayAnios: number[] = []
    for (var i = n; i <= n + 10; i++) {
      arrayAnios.push(i);
    }

    return arrayAnios;
  }

  const motivosDescargosRadar = [
    "CARTELERIA",
    "HOMOLOGACIÓN",
    "CAMBIO DE TITULAR CON RELACIÓN AL DUEÑO DEL DOMINIO",
    "ERROR EN LECTURA DEL DOMINIO (BORROSO, SIN POSIBILIDAD DE DISTINGUIRSE)",
    "PATENTE NO COINCIDE CON EL VEHÍCULO REAL",
    "SERVICIO DE CONTROLES POR MICROTRACK",
    "OTRO"
  ]

  const discountsOptions = [
    { value: 5, label: '5%' },
    { value: 10, label: '10%' },
    { value: 15, label: '15%' },
    { value: 20, label: '20%' },
    { value: 25, label: '25%' },
    { value: 30, label: '30%' },
    { value: 35, label: '35%' },
    { value: 40, label: '40%' },
    { value: 45, label: '45%' },
    { value: 50, label: '50%' },
  ];


   let estadisticasAnioDefault = [
    {
      "label": "Ene",
      "key": 1,
      "value": 0
    },
    {
      "label": "Feb",
      "key": 2,
      "value": 0

    },
    {
      "label": "Mar",
      "key": 3,
      "value": 0

    },
    {
      "label": "Abr",
      "key": 4,
      "value": 0

    },
    {
      "label": "May",
      "key": 5,
      "value": 0

    },
    {
      "label": "Jun",
      "key": 6,
      "value": 0
    },
    {
      "label": "Jul",
      "key": 7,
      "value": 0
    },
    {
      "label": "Ago",
      "key": 8,
      "value": 0
    },
    {
      "label": "Sept",
      "key": 9,
      "value": 0
    },
    {
      "label": "Oct",
      "key": 10,
      "value": 0
    },
    {
      "label": "Nov",
      "key": 11,
      "value": 0
    },
    {
      "label": "Dic",
      "key": 12,
      "value": 0
    },
  ];

  let estadisticasDiasDefault = [
    {
      "key": 1,
      "value": 0
    },
    {
      "key": 2,
      "value": 0

    },
    {
      "key": 3,
      "value": 0

    },
    {
      "key": 4,
      "value": 0

    },
    {
      "key": 5,
      "value": 0

    },
    {
      "key": 6,
      "value": 0
    },
    {
      "key": 7,
      "value": 0
    },
    {
      "key": 8,
      "value": 0
    },
    {
      "key": 9,
      "value": 0
    },
    {
      "key": 10,
      "value": 0
    },
    {
      "key": 11,
      "value": 0
    },
    {
      "key": 12,
      "value": 0
    },
    {
      "key": 13,
      "value": 0
    },
    {
      "key": 14,
      "value": 0
    },
    {
      "key": 15,
      "value": 0
    },
    {
      "key": 16,
      "value": 0
    },
    {
      "key": 17,
      "value": 0
    },
    {
      "key": 18,
      "value": 0
    },
    {
      "key": 19,
      "value": 0
    },
    {
      "key": 20,
      "value": 0
    },
    {
      "key": 21,
      "value": 0
    },
    {
      "key": 22,
      "value": 0
    },
    {
      "key": 23,
      "value": 0
    },
    {
      "key": 24,
      "value": 0
    },
    {
      "key": 25,
      "value": 0
    },
    {
      "key": 26,
      "value": 0
    },
    {
      "key": 27,
      "value": 0
    },
    {
      "key": 28,
      "value": 0
    },
    {
      "key": 29,
      "value": 0
    },
    {
      "key": 30,
      "value": 0
    },
    {
      "key": 31,
      "value": 0
    },
  ];

  const provinciasList = [
    "BUENOS AIRES",
    "CATAMARCA",
    "CHACO",
    "CHUBUT",
    "CORDOBA",
    "CORRIENTES",
    "CAPITAL FEDERAL",
    "ENTRE RIOS",
    "FORMOSA",
    "JUJUY",
    "LA PAMPA",
    "LA RIOJA",
    "MENDOZA",
    "MISIONES",
    "NEUQUEN",
    "RIO NEGRO",
    "SALTA",
    "SAN JUAN",
    "SAN LUIS",
    "SANTA CRUZ",
    "SANTA FE",
    "SANTIAGO DEL ESTERO",
    "TIERRA DEL FUEGO",
    "TUCUMAN"
  ]

  const keywordsOrganismos = ["salud", "bomberos", "policia", "policía", 
    "Policía", "ministerio","Salud","Bomberos",
    "Policia","Ministerio","secretaria", "secretaría", 
    "Secretaría", "Secretaria","gendarmeria", "Gendarmeria", 
    "gendarmería", "Gendarmería", "emergencia", "Emergencia", 
    "seguridad", "Seguridad", "defensa", "Defensa", 
    "hospital", "Hospital", "prefectura", "Prefectura", 
    "comite", "Comite", "comité", "Comité", "ejercito", 
    "Ejercito", "ejército", "Ejército", "armada", 
    "Armada", "medica", "Medica", "médica", 
    "Médica", "emergencias", "Emergencias", "cruz roja", 
    "Cruz Roja", "ambulancia", "Ambulancia", "federal", 
    "Federal", "nacion", "Nacion", "nación", 
    "Nación", "municipalidad", "Municipalidad", "cuerpo", 
    "Cuerpo", "marina", "Marina", "centro", 
    "Centro", "fuerza", "Fuerza", "coordinacion", 
    "Coordinacion", "coordinación", "Coordinación", 
    "metropolitana", "Metropolitana", "direccion", "Direccion", 
    "dirección", "Dirección", "instituto", "Instituto", 
    "escuela", "Escuela", "facultad", "Facultad", 
    "universidad", "Universidad", "nacional", "Nacional", 
    "camara", "Camara", "cámara", "Cámara", 
    "Provincia", "provincial", "Provincial", "poder", 
    "Poder", "judicial", "Judicial", "brocart", 
    "Brocart", "fluxa", "Fluxa", "energia", 
    "Energia", "energía", "Energía", "asociacion", 
    "Asociacion", "asociación", "Asociación", "estado", 
    "Estado", "gobernacion", "Gobernacion", "gobernación", 
    "Gobernación", "provincia", "gob", "municipal",
    "pcia", "muni"];

  function formatNumberMoneda(numero: number = 0): string {
    const opcionesFormato = {
      style: 'currency',
      currency: 'ARS',
      minimumFractionDigits: 2,
    };
  
    return numero.toLocaleString('es-AR', opcionesFormato);
  }

  return {
    getYearsStats,
    getEstadisticasAnioDefault:()=>estadisticasAnioDefault,
    getEstadisticasDiasDefault:()=>estadisticasDiasDefault,
    getProvinciasList:()=>provinciasList,
    getMotivosDescargosRadar: () => motivosDescargosRadar,
    getKeywordsOrganismos: () => keywordsOrganismos,
    formatNumberMoneda: (numero: number) => formatNumberMoneda(numero),
    getDiscountOptions: () => discountsOptions,
  };

};
